<template>
  <div class="auctionResult">
    <yearSwiper @clickYearSwiper="clickYearSwiper"></yearSwiper>
    <auctionList :auctionLists="auctionLists"></auctionList>
    <pagination @clickPagination="clickPagination" :item="statics"/>
  </div>
</template>

<script>
// 调用接口
import { postDetail, getSession } from "@/api/company";

import auctionList from "./auctionList";
import yearSwiper from "./yearSwiper";
import pagination from './pagination.vue'

export default {
  name: "auctionResult",
  components: {
    auctionList,
    yearSwiper,
    pagination
  },
  data() {
    return {
      aucViews: {
        organ_code: "",
        page: 1,
        page_size: 5,
        is_total: 1,
        status: 1,
        ord: 6,
        only_meta: 2,
        start_time: '',
        end_time: ''
      },
      auctionLists: [],
      statics: 0
    };
  },
  mounted() {
    const webName = this.$router.history.current.params.name;
    this.postDetail(webName);
  },
  methods: {
    postDetail(name) {
      postDetail({
        web_name: name,
      }).then((res) => {
        this.aucViews.organ_code = res.data.organ_id;
          this.aucViews.special_top = 50
        this.getSession();
      });
    },
    getSession() {
      getSession(this.aucViews).then((res) => {
          this.auctionLists = res.data.dataList
          this.statics = res.data.static.pages
      });
    },
    clickPagination(item) {
        this.aucViews.page = item
        this.getSession()
    },
    clickYearSwiper(item) {
      if(item == '全部') {
        this.aucViews.start_time = ''
        this.aucViews.end_time = ''
      } else {
        this.aucViews.start_time = item + '-01-01'
        this.aucViews.end_time = item + '-12-31'
      }
      this.getSession()
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
</style>